import React from "react";
import LinkButton from "src/components/buttons/LinkButton";
import { useMediaQueries } from "src/utils/useMediaQueries";
import Modal from "../modals/Modal";

interface Props {
  visible: boolean;
  onCancel: () => void;
  onDone?: () => void;
  content?: React.ReactNode;
}

export function FilterContainer(props: Props) {
  const { small } = useMediaQueries();

  if (small) {
    return (
      <div>
        <Modal
          visible={props.visible}
          handleCancel={props.onCancel}
          hideClose
          title={
            <div className="flex">
              <div className="flex-1">
                <LinkButton className="text-error" onClick={props.onCancel}>
                  Clear All
                </LinkButton>
              </div>
              <div>
                <LinkButton
                  onClick={() => {
                    if (props.onDone) {
                      props.onDone();
                    } else {
                      props.onCancel();
                    }
                  }}
                >
                  <strong>Done</strong>
                </LinkButton>
              </div>
            </div>
          }
        >
          <div className="-mx-4 -mt-4">{props.content}</div>
        </Modal>
      </div>
    );
  }

  return (
    <div
      className="overflow-auto border-l border-borderGray bg-white pb-3 transition-all"
      css={{
        width: 375,
        opacity: props.visible ? 1 : 0,
        marginRight: props.visible ? 0 : -375,
      }}
    >
      {props.content}
    </div>
  );
}

export const CollapseHeader = (props) => {
  const { title, subheader, clear } = props;
  return (
    <div>
      <div className="flex items-center justify-between">
        <div>{title}</div>
        {clear ? (
          <button
            className="p2 ml-auto cursor-pointer text-organization hover:opacity-75"
            onClick={(event) => {
              event.stopPropagation();
              clear();
            }}
          >
            Clear
          </button>
        ) : (
          <i
            aria-hidden
            className="far fa-circle-plus ml-2 text-organization"
          />
        )}
      </div>
      {subheader && <h4 className="mb-0 truncate text-empty">{subheader}</h4>}
    </div>
  );
};
